<template>
<div class="main-body">
  <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    RMA Products
                  </h4>
              </div><!--col-->

              <div class="col-sm-7">
                  <div class="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                     <b-button type="button" size="sm" variant="warning ml-1" @click="addRmaProduct"><i class="fa fa-plus"></i> 
                    {{ $t('marketplace.rma_product.manual_create') }}
                    </b-button>
                    <router-link :to="{ path: '/rma-product/create' }" class="btn btn-primary ml-1" data-toggle="tooltip" title="Create New">
                      <i class="fa fa-plus"></i>
                    </router-link>
                  </div><!--btn-toolbar-->
              </div><!--col-->
          </div><!--row-->
          <hr />
          <rma-product-filters :filter="filter" :fetchRmaProducts="searchMarketplaceRmaProducts"></rma-product-filters>
          <div class="row mt-4">
              <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <colgroup>
                          <col width="2%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="10%">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th>{{ $t('marketplace.rma_product.document_no') }}</th>
                            <th>{{ $t('marketplace.rma_product.platform') }}</th>
                            <th>{{ $t('marketplace.rma_product.platform_order_id') }}</th>
                            <th>{{ $t('marketplace.rma_product.order_item_id') }}</th>
                            <th>{{ $t('marketplace.rma_product.imei_code') }}</th>
                            <th>{{ $t('marketplace.rma_product.product_name') }}</th>
                            <th>{{ $t('marketplace.rma_product.qty') }}</th>
                            <th>{{ $t('marketplace.rma_product.conditions') }}</th>
                            <th>{{ $t('marketplace.rma_product.deal_price') }}</th>
                            <th>{{ $t('marketplace.rma_product.selling_price') }}</th>
                            <!-- <th>{{ $t('marketplace.rma_product.selling_price') }}</th>
                            <th>{{ $t('marketplace.rma_product.sold_date') }}</th> -->
                            <th>{{ $t('marketplace.rma_product.status') }}</th>
                            <th>{{ $t('marketplace.rma_product.operation') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(rmaProduct, index) in rmaProducts" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>
                              <a href="#" @click="showRamProductDetail(rmaProduct)">
                               {{ rmaProduct.document_no }}
                              </a>
                            </td>
                            <td>{{ rmaProduct.platform }}</td>                 
                            <td>{{ rmaProduct.platform_order_id }}</td>
                            <td>{{ rmaProduct.order_item_id }}</td>
                            <td>{{ rmaProduct.imei_code }}</td>
                            <td>{{ rmaProduct.product_name }}</td>
                            <td>{{ rmaProduct.qty }}</td>
                            <td>{{ rmaProduct.conditions }}</td>
                            <td>{{ rmaProduct.deal_price }}</td>
                            <td>{{ rmaProduct.selling_price }}</td>
                            <td v-html="rmaProduct.status_label"></td>
                            <td>
                              <b-button v-if="rmaProduct.action_buttons && rmaProduct.action_buttons.bookInButton"  type="button" size="sm"  data-toggle="tooltip" title="Book In Product" variant="info ml-1" @click="bookInRmaProduct(rmaProduct)">
                                <i class="fa fa-arrow-right" aria-hidden="true"></i>
                              </b-button>
                              <router-link v-if="rmaProduct.action_buttons && rmaProduct.action_buttons.editButton" :to="{ path: '/rma-product/' + rmaProduct.id + '/edit' }">
                                <b-button variant="primary btn-sm ml-1" data-toggle="tooltip" title="Edit"><i class="fa fa-pencil"></i></b-button>
                              </router-link>
                              <b-button v-if="rmaProduct.action_buttons && rmaProduct.action_buttons.downloadDeliveryNote" size="sm" variant="success ml-1" data-toggle="tooltip" title="Download" @click.stop.prevent="downloadDelivery(rmaProduct.document_no, rmaProduct.id)"><i class="fa fa-print"></i></b-button>
                              <b-button v-if="rmaProduct.action_buttons && rmaProduct.action_buttons.settledButton" variant="warning btn-sm ml-1" data-toggle="tooltip" title="Settled" @click.stop.prevent="handleSettled(rmaProduct.id)"><i class="fa fa-check-circle-o "></i></b-button>
                              <b-button v-if="rmaProduct.action_buttons && rmaProduct.action_buttons.lostButton" variant="danger btn-sm ml-1" data-toggle="tooltip" title="Mark As Lost" @click.stop.prevent="handleMarkAsLost(rmaProduct.id)"><i class="fa fa-exclamation-triangle"></i></b-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="row" v-if="rmaProductsMeta">
                        <div class="col-sm-12 col-md-5">
                          <div class="mt-2" aria-live="polite">{{ $t('general.list.display') }} {{ rmaProductsMeta.from }} {{ $t('general.list.to') }} {{ rmaProductsMeta.to }} {{ $t('general.list.of') }} {{ rmaProductsMeta.total }} {{ $t('general.list.records') }}</div>
                        </div>
                        <div class="col-sm-12 col-md-7">
                          <nav>
                            <b-pagination align="end" :total-rows="rmaProductsMeta.total" :per-page="rmaProductsMeta.per_page" :value="currentPage" :prev-text="$t('general.list.prev')"  :next-text="$t('general.list.next')" @change='changePage'/>
                          </nav>
                        </div>>
                      </div>
                  </div>
              </div><!--col-->
          </div><!--row-->
      </div><!--card-body-->
  </div><!--card-->
  <loading-panel v-if="showLoadingPanel"></loading-panel>
  <CModal
    title="RMA Product Detail"
    :show.sync="modalDetailShow"
    color="primary"
    size="xl"
  >
    <rma-product-detail :rmaProductDetail="selectedRmaProduct"></rma-product-detail>
    <div slot="footer"></div>
  </CModal>
  <CModal
      title="Add Rma Product"
      :show.sync="modalRmaProductShow"
      color="primary"
      size="xl"
    >
      <add-rma-product-form v-if="modalRmaProductShow" :callback="handleCreateProductCallback" createType="manual"></add-rma-product-form>
      <div slot="footer"></div>
    </CModal>
    <CModal
      title="Book In Product"
      :show.sync="modalBookInShow"
      color="primary"
      size="xl"
    >
      <book-in-product-form v-if="bookRmaProduct" :callback="handleBookInProductCallback" :rmaProduct="bookRmaProduct"></book-in-product-form>
      <div slot="footer"></div>
    </CModal>
</div>
</template>

<script>
import RmaProductFilters from '@/views/components/marketplace/rma_product/RmaProductFilters'
import RmaProductDetail from '@/views/components/marketplace/rma_product/RmaProductDetail'
import AddRmaProductForm from '@/views/components/marketplace/rma_product/AddRmaProductForm.vue'
import BookInProductForm from '@/views/components/marketplace/rma_product/BookInProductForm.vue'

import LoadingPanel from '@/components/LoadingPanel'

export default {
  name: 'RmaProducts',
  components: {
    RmaProductFilters,
    RmaProductDetail,
    AddRmaProductForm,
    BookInProductForm,
    LoadingPanel
  },
  mounted () {
    this.searchMarketplaceRmaProducts() 
  },
  data () {
    return {
      rmaProducts: [],
      bookRmaProduct: null,
      rmaProductsMeta: null,
      filter: {
        platform_order_id: "",
        imei_code: "",
        product_name: "",
        platform: null,
        conditions: null,
        status: null
      },
      selectedRmaProduct: null,
      currentPage: 1,
      modalDetailShow: false,
      modalRmaProductShow: false,
      modalBookInShow: false,
      showLoadingPanel: false
    }
  },
  methods: {
    addRmaProduct() {
       this.modalRmaProductShow = true
    },
    bookInRmaProduct(item) {
       this.modalBookInShow = true
       this.bookRmaProduct = item
    },
    handleCreateProductCallback() {
      this.modalRmaProductShow = false
      // show index page latest add RMA product
      this.searchMarketplaceRmaProducts();
    },
    handleBookInProductCallback() {
      this.modalBookInShow = false
      this.bookRmaProduct = null
      this.searchMarketplaceRmaProducts() 
    },
    downloadDelivery (documentNo, id) {
      this.axios.get('/marketplace/rma-product/' + id + '/download-dn', {
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = documentNo + '.pdf'
        link.click()
      }).catch(error => {
        console.log(error)
      })
    },
    searchMarketplaceRmaProducts(){
      this.axios.get('/marketplace/rma-product', {
        params: {
          ...this.filter,
          page: this.currentPage
        }
      }).then(response => {
        this.rmaProducts = response.data
        this.rmaProductsMeta = response.meta
      }).catch(error => {
        console.log(error)
      })
    },
    showRamProductDetail(item){
      this.selectedRmaProduct = item
      this.modalDetailShow = true
    },
    changePage (pageNum) {
      this.currentPage = pageNum
      this.searchMarketplaceRmaProducts();
    },
    handleSettled (rmaProductId) {
      this.$swal({
        title: this.$t('marketplace.rma_product.settled.title'),
        text: this.$t('marketplace.rma_product.settled.text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('marketplace.rma_product.settled.confirm_button')
      }).then((result) => {
        if (result.value) {
          this.showLoadingPanel = true
          this.axios.post('/marketplace/rma-product/' + rmaProductId + '/settled').then(() => {
            // this.showLoadingPanel = false
            // this.$router.push('/marketplace/store')
            location.reload()
          }).catch(error => {
            this.showLoadingPanel = false
            this.$swal({
              icon: 'error',
              title: error.data.message
            })
          })
        }
      })
    },
    handleMarkAsLost (rmaProductId) {
      this.$swal({
        title: this.$t('operation.rma_lost.title'),
        text: this.$t('operation.rma_lost.text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#7066e0',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('operation.rma_lost.confirm_button')
      }).then((result) => {
        if (result.value) {
          this.showLoadingPanel = true
          this.axios.post('/marketplace/rma-product/' + rmaProductId + '/mark-lost').then(() => {
            // this.showLoadingPanel = false
            // this.$router.push('/marketplace/store')
            location.reload()
          }).catch(error => {
            this.showLoadingPanel = false
            this.$swal({
              icon: 'error',
              title: error.data.message
            })
          })
        }
      })
    }
  }
}
</script>
